'use client'

import { createContext, useContext, useEffect, useState } from 'react'
import { retrieveCart } from '@onclicks/sharedmedusa/medusaData/cart'

type NumberItemsCartContextType = {
  addQuantity: (quantity: number) => void
  setQuantity: (quantity: number) => void
  refreshQuantity: () => Promise<void>
  totalItems: number
}

const NumberItemsCartContext = createContext<NumberItemsCartContextType | null>(null)

type NumberItemsCartProviderProps = {
  children: React.ReactNode
  value?: string
}

export const NumberItemsCartProvider = ({ children }: NumberItemsCartProviderProps) => {
  const [totalItems, setTotalItems] = useState(0)

  const fetchMedusaCart = async () => {
    try {
      const cart = await retrieveCart()
      const numberItems = cart?.items?.reduce((acc, item) => acc + item.quantity, 0) ?? 0
      setTotalItems(numberItems)
    } catch (error) {
      console.error("Erreur lors de la récupération du panier ou du nombre d'articles:", error)
    }
  }

  useEffect(() => {
    fetchMedusaCart()
  }, [])

  const addQuantity = (quantity: number) => {
    setTotalItems((prev) => prev + quantity)
  }

  const setQuantity = (quantity: number) => {
    setTotalItems(quantity)
  }

  return (
    <NumberItemsCartContext.Provider
      value={{
        addQuantity,
        setQuantity,
        refreshQuantity: fetchMedusaCart,
        totalItems,
      }}
    >
      {children}
    </NumberItemsCartContext.Provider>
  )
}

export const useNumberItemsCart = () => {
  const context = useContext(NumberItemsCartContext)

  if (!context) {
    throw new Error('useNumberItemsCart must be used within a RegionProvider')
  }

  return context
}
